import { Layout, Page, ContextualSaveBar } from "@shopify/polaris";
import { useRef, useEffect } from "react";
import { useHistory } from "react-router";
import { useMutation } from "react-query";

import { createOneEducator } from "api";
import { useSnackbar } from "providers";
import { SharedForm } from "../SharedForm/SharedForm";

export function NewEducator(props) {
  const skipToContentRef = useRef(null);

  const initialValues = useRef({
    name: "",
    email: "",
    tel: "",
    password: "123456",
    avatar: undefined,
    status: "Aktif",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { toggleSnack } = useSnackbar();

  const postMutation = useMutation(createOneEducator, {
    onSuccess: (response) => {
      toggleSnack({
        key: "paymentCreateSuccess",
        message: "Eğitmen kaydı başarıyla oluşturulmuştur",
        active: true,
      });
    },
    onError: (error) => {
      toggleSnack({
        key: "paymentCreateError",
        error: true,
        message: error?.response?.data?.message,
        active: true,
      });
    },
  });

  return (
    <Page
      title="Yeni Eğitmen"
      narrowWidth={true}
      breadcrumbs={[{ content: "Eğitmenler", url: "/educators" }]}
    >
      <Layout>
        <a id="SkipToContentTarget" ref={skipToContentRef} tabIndex={-1} />
        <SharedForm
          onSubmit={(values) => postMutation.mutate(values)}
          initialValues={initialValues.current}
          savebarRender={(values) => (
            <Savebar {...values} isLoading={postMutation.isLoading} />
          )}
        />
      </Layout>
    </Page>
  );
}

function Savebar({ handleSubmit, isValid, isLoading }) {
  const history = useHistory();
  return (
    <ContextualSaveBar
      saveAction={{
        onAction: handleSubmit,
        loading: isLoading,
        disabled: !isValid,
        content: "Kaydet",
      }}
      message="Yeni Eğitmen"
      discardAction={{
        onAction: () => history.push("/educators"),
        content: "Geri",
      }}
    />
  );
}
